/* eslint-disable no-useless-constructor */
import React, { useRef, useEffect, useState, useMemo } from 'react'
import { withTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import styles from './Confirmation.module.scss'
import PrintComponent from './PrintComponent'
import SaveCopy from './SaveCopy'

export const PrintContent1 = ({ t, i18n, emailAddress, paymentTransactionNum, transId, transOwner }) => {
  // const t = this.props.t
  // const i18n = this.props.i18n
  // const emailAddress = this.props.emailAddress
  // const paymentTransactionNum = this.props.paymentTransactionNum
  const handleGoBackToStart = (e) => {
    e.preventDefault()
    const url = i18n.language === 'en' ? process.env.REACT_APP_PAGE_NOT_FOUND_URL : process.env.REACT_APP_PAGE_NOT_FOUND_URL_FR

    window.location.replace(url)
  }

  return (
    <div className={'container'}>
      <div style={{ display: 'flex' }}>
        <div
          style={{
            display: 'flex',
            marginLeft: '-60px',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '30px',
          }}
        >
          <div className={'col-xs-1 ' + styles['success_margin_right']}>
            <i className="fa fa-check-circle fa-2x" aria-hidden="true"></i>
          </div>
          <div style={{ flexGrow: 1, backgroundColor: 'green', width: '5px' }} />
        </div>
        <div style={{ flexGrow: 1 }}>
          <div className="col-xs-12">
            <div className="row">
              <div className="col-xs-12">
                <h1 style={{ color: 'green' }}>{t('confirmation.title')}</h1>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-lg-12">
                <h2 style={{ marginTop: '5px' }}>
                  {t('confirmation.transaction_number')} <strong>{paymentTransactionNum}</strong>
                </h2>
                <h3 style={{ marginBottom: '15px' }}>{t('confirmation.we_have_emailed')} </h3>
                <h4 style={{ marginBottom: '30px' }}>{t('confirmation.print_or_save')}</h4>
              </div>
            </div>

            <div className="print_no_display">
              <div className="row">
                <div style={{ display: 'flex', flexGrow: 1 }}>
                  <div className={styles['display_flex']}>
                    <div className={styles['back_center']}>
                      {typeof InstallTrigger !== 'undefined' || /*@cc_on!@*/ false || !!document.documentMode ? null : (
                        <PrintComponent transId={transId} transOwner={transOwner} />
                      )}
                      <SaveCopy transId={transId} transOwner={transOwner} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12">
                  <a
                    href={
                      i18n.language === 'en'
                        ? 'https://beta.novascotia.ca/make-payment-your-collection-services-account'
                        : 'https://beta.novascotia.ca/fr/faire-un-paiement-votre-compte-des-services-de-recouvrements'
                    }
                    className={styles['all_finished_link']}
                    onClick={handleGoBackToStart}
                  >
                    {t('confirmation.all_finished')} <span className="ns-visually-hidden">(ouvre dans un nouvel onglet)</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const ConfirmationView = ({ t, i18n, setIsError }) => {
  const pageElem = useRef()
  const location = useLocation()

  const [paymentTransactionNum, setPaymentTransactionNum] = useState('')
  const [transId, setTransId] = useState('123456')
  const [transOwner, setTransOwner] = useState('test Test')
  const [emailAddress, setEmailAddress] = useState('')

  const { payeeContactInformation, contactInformation } = useSelector((state) => state.app)

  useEffect(() => {
    try {
      // dispatch(clearAllAction())
      // dispatch(logoutAction()).catch((e) => {
      //   console.log(e)
      // })
      if (!location.state) {
        return
      }
      if (location.state.transNum) {
        setPaymentTransactionNum(location.state.transNum)
      }
      if (location.state.emailAddress) {
        setEmailAddress(location.state.emailAddress)
      }
      if (location.state.transId) {
        setTransId(location.state.transId)
      }
      if (location.state.transOwner) {
        setTransOwner(location.state.transOwner)
      }
      if (location.state && location.state.transNum && location.state.emailAddress && location.state.transId && location.state.transOwner) {
        setTransId(location.state.transId)
        setTransOwner(location.state.transOwner)
        setEmailAddress(location.state.emailAddress)
      } else {
        // history.push(`/${i18n.language}${t('routes.privacy_notice')}`)
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [location.state, setIsError])

  const emailStr = useMemo(() => {
    return payeeContactInformation ? `${emailAddress} ${t('shared.and')} ${contactInformation.email}` : emailAddress
  }, [emailAddress, payeeContactInformation, contactInformation, t])

  return (
    <React.Fragment>
      <div ref={pageElem} style={{ marginBottom: '2rem' }}>
        <PrintContent1
          i18n={i18n}
          t={t}
          emailAddress={emailAddress}
          paymentTransactionNum={paymentTransactionNum}
          transId={transId}
          transOwner={transOwner}
        />
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-lg-12">
              <h2>{t('confirmation.what_happens_next')}</h2>
              <div className="row">
                <div className="col-xs-12">
                  <strong>{t('confirmation.confirmation_email')}</strong>
                  <br />
                  {t('confirmation.confirmation_email_info')} {emailStr}
                  <br />
                  {t('confirmation.confirmation_email_info_cont')}
                </div>
              </div>
              <br />
              <div className="row">
                <div className="col-xs-12 col-md-9">
                  <strong>{t('confirmation.payment_processed')}</strong>
                  <br />
                  {t('confirmation.payment_processed_info')}
                </div>
              </div>

              <div className="row">
                <div className="col-xs-12 col-md-8">
                  <h3>{t('confirmation.if_you_have_questions')}</h3>
                  {t('confirmation.if_you_have_questions_info')}
                </div>
              </div>
              <br />
              <div className="row">
                <div className="col-md-8">
                  <div style={{ display: 'flex', flexGrow: 1 }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <span>
                        <strong>{t('confirmation.contact')}</strong>
                      </span>
                      <span>
                        <strong>{t('confirmation.telephone')}</strong>
                      </span>
                      <span>
                        <strong>{t('confirmation.email')}</strong>
                      </span>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '2rem' }}>
                      <span>
                        <a target="_blank" href="https://novascotia.ca/just/?_ga=2.6217335.531074892.1751473309-574972600.1739459229">
                          {t('confirmation.contact_info')}
                        </a>
                      </span>
                      <span>
                        <a href={`tel:${t('confirmation.telephone_num')}`}>{t('confirmation.telephone_num')}</a>
                      </span>
                      <span>
                        <a href={`mailto:${t('confirmation.email_address')}`}>{t('confirmation.email_address')}</a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="row">
                <div className="col-xs-12 col-md-8">
                  <div style={{ display: "flex" }}>
                    <span><strong>{t('confirmation.telephone')}</strong></span>
                    <span style={{ marginLeft: '1rem' }}>{t('confirmation.telephone_num')}</span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12 col-md-8">
                  <div style={{ display: "flex" }}>
                    <span className="col"><strong>{t('confirmation.email')}</strong></span>
                    <span className="col" style={{ marginLeft: '1rem' }}>{t('confirmation.email_address')}</span>
                    <div className="col" style={{ flexGrow: 1 }}></div>
                  </div>
                </div>
              </div> */}
              <div className="row">
                <div className="col-xs-12 col-md-8">
                  <h3>{t('confirmation.late_paying_ques')}</h3>
                  {t('confirmation.late_paying_ans')}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default withTranslation('common')(ConfirmationView)
